import { render, staticRenderFns } from "./PersonalPaymentsDetailSubPage.vue?vue&type=template&id=52c142c8&"
import script from "./PersonalPaymentsDetailSubPage.vue?vue&type=script&lang=ts&"
export * from "./PersonalPaymentsDetailSubPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports